<template>
    <nav id="navigation" v-if="utilisateur.is_logged_in">
        <!-- Navigation view -->
        <div id="container-navigation">
            <div id="menu-jeu">
                <!-- MENU DROITE -->
                <div id="droite" class="d-flex float-end">
                    <!-- Afficher le bouton des tickets uniquement pour les utilisateurs ayant le rôle de testeur ou supérieur --> 
                    <!-- Ticket asana -->
                    <div  
                        v-if="user_can( 'testeur' )"
                        data-bs-toggle="tooltip"
                        data-bs-placement="bottom"
                        title="Créer un ticket"
                    >
                        <button
                            id="ticket-asana"
                            type="button"
                            class="btn btn-primary"
                            data-bs-toggle="modal"
                            data-bs-target="#asanaModal"
                        >
                            Créer un ticket
                        </button>
                    </div>
        
                    <!-- Access Admin -->
                     <!-- Affichez l'icône pour recommencer une mission si la position du joueur existe. -->
                    <div
                        v-if="user_can( 'admin' ) && joueur_position.id_mission"
                        class="picto fond picto-recommencer-mission"
                        data-bs-toggle="tooltip"
                        data-bs-placement="bottom"
                        title="Recommencer mission"
                    >
                        <div class="wrap">
                            <form action="/mission" method="post">
                                <input type="hidden" :value='this.csrfTokenValue' :name="this.csrfTokenName">
                                <input type="hidden" name="id_mission" :value="joueur_position.id_mission" />
                                <input type="hidden" name="type_formulaire" value="start_mission" />
                                <input type="image" src="images/pictos/restart.svg" />
                            </form>
                        </div>
                    </div>
    
                    <!-- Affichez l'icône pour recommencer au début de la mission si la position du joueur existe. -->
                    <div 
                        v-if="user_can( 'admin' ) && joueur_position.id_mission"
                        class="picto fond picto-recommencer-debut-mission"
                        data-bs-toggle="tooltip"
                        data-bs-placement="bottom"
                        title="Revenir au début de la mission"
                    >
                        <div class="wrap">
                            <form action="/jeu" method="post">
                                <input type="hidden" :value='this.csrfTokenValue' :name="this.csrfTokenName">
                                <input type="hidden" name="type" value="mission" />
                                <input type="hidden" name="id_parent" :value="joueur_position.id_mission" />
                                <input id="image-refresh" type="image" src="images/pictos/refresh.svg" />
                            </form>
                        </div>
                    </div>
        
                    <!-- Picto admin -->
                    <a
                        v-if="user_can( 'admin' )"
                        href="admin/dashboard"
                        data-bs-toggle="tooltip"
                        data-bs-placement="bottom"
                        title="Admin"
                    >
                        <div class="picto fond">
                            <div class="wrap">
                                <img src="images/pictos/admin.svg" alt="admin" />
                            </div>
                        </div>
                    </a>
    
                    <!-- Terminer la mission -->
                    <div
                        v-if="user_can( 'admin' )"
                        class="picto fond picto-end-mission"
                        data-bs-toggle="tooltip"
                        data-bs-placement="bottom"
                        title="Terminer la mission"
                    >
                        <div class="wrap">
                            <form action="/end-mission" method="post">
                                <input type="hidden" :value='this.csrfTokenValue' :name="this.csrfTokenName">
                                <input type="hidden" name="id_joueur_mission" :value="joueur_position.id_joueur_mission" />
                                <input type="hidden" name="id_joueur" :value="joueur_position.id_joueur" />
                                <input type="hidden" name="id_mission" :value="joueur_position.id_mission" />
                                <input id="image-end-mission" type="image" src="images/pictos/restart.svg" />
                            </form>
                        </div>
                    </div>
                    <!-- End Access Admin -->
        
                    <!-- Afficher le picto robot pour les codex -->
                    <div
                        v-if="mission && list_codex.chatbot && list_codex.chatbot.length" 
                        id="picto-container-codex-dialogue"
                        class="picto" data-bs-toggle="tooltip"
                        data-bs-placement="bottom"
                        data-bs-trigger="hover"
                        title="Jean-Watt"
                    >
                        <div class="wrap">
                            <input id="image-codex-robot" class="show-modal" data-id-modal="container-modal-codex-dialogue" type="image" src="images/pictos/robot-codex.png" />
                        </div>
                    </div>
        
                    <!-- Recommencer le jeu depuis le début -->
                    <div
                        id="picto-recommencer-jeu"
                        class="picto fond picto-recommencer-jeu"
                        data-bs-toggle="tooltip"
                        data-bs-placement="bottom"
                        data-bs-trigger="hover"
                        title="Recommencer le jeu"
                    >
                        <div class="wrap">
                            <form action='/mission' method="post">
                                <input type="hidden" :value='this.csrfTokenValue' :name="this.csrfTokenName">
                                <input type="hidden" name="id_mission" value="1" />
                                <input type="hidden" name="type_formulaire" value="start_mission" />
                                <input id="image-restart-mission" type="image" src="images/pictos/restart-game.svg" />
                            </form>
                        </div>
                    </div>
        
                    <!-- Affiche le bouton "Statistiques" si  utilisateur à les droits -->
                    <!-- Picto des statistiques -->
                    <a
                        v-if="user_can( 'client' )"
                        href="/list-statistiques"
                        data-bs-toggle="tooltip" 
                        data-bs-placement="bottom" 
                        title="Statistiques"
                    >
                        <div class="picto fond">
                            <div class="wrap">
                                <img src="images/pictos/statistiques.svg" alt="Statistiques"/>
                            </div>
                        </div>             
                    </a>
        
                    <!-- Plein Écran -->
                    <div
                        id="picto-plein-ecran"
                        class="picto fond"
                        data-bs-toggle="tooltip"
                        data-bs-placement="bottom"
                        title="Plein écran"
                    >
                        <div class="wrap">
                            <img src="images/pictos/icone-plein-ecran.svg" alt="plein écran" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</template>
  
<script>
    /* eslint-disable */ 
    export default {
        name: 'NavigationComponent',
        props: {
            utilisateur: {
                type: Object,
                default: null,
            },
            joueur_position: {
                type: Object,
                default: null,
            },
            mission: {
                type: Object,
                default: null,
            },
            list_codex: {
                type: Object,
                default: null,
            },
            csrfTokenName: {
                type: String,
                required: true
            },
            csrfTokenValue: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                // Initialize routes as an empty object
                routes: {}
            };
        },
        methods: {
            user_can(role) {
                const roles = {
                    joueur: 1,
                    client: 2,
                    testeur: 3,
                    webmaster: 4,
                    admin: 5,
                };
                return this.utilisateur.utilisateur && this.utilisateur.utilisateur.id_role >= ( roles[ role ] || 0);
            },
        },
    };
</script>